import { createReducer, on } from '@ngrx/store';
import {
  WidgetSnippetVersionsLoadedAction,
  ProjectCodeSnippetInitializedAction,
  WidgetSnippetVersionsRequestErroredAction,
} from './widget-snippet.actions';

export interface WidgetSnippetState {
  versions: string[];
  loading: boolean;
  apiError: boolean;
}

export const initialState: WidgetSnippetState = {
  versions: [],
  loading: false,
  apiError: false,
};

export const widgetSnippetReducer = createReducer(
  initialState,
  on(ProjectCodeSnippetInitializedAction, (state) => ({
    ...state,
    loading: true,
    apiError: false,
  })),
  on(WidgetSnippetVersionsRequestErroredAction, (state) => ({
    ...state,
    loading: false,
    apiError: true,
  })),
  on(WidgetSnippetVersionsLoadedAction, (state, { versions }) => ({
    ...state,
    apiError: false,
    loading: false,
    versions,
  })),
);
